export default "__VITE_ASSET__BgUhzWRH__"